// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { PanelBody } from "@wordpress/components";
import { RichText, InspectorControls } from "@wordpress/block-editor";
import AttributesEditor from "../../components/Gutenberg/AttributesEditor";

// Internal dependencies
import IconsWithDescription from "./IconsWithDescription";

import protest from "../../assets/icons/Protester.svg";
import mountain from "../../assets/icons/Uluru.svg";
import kangaroo from "../../assets/icons/Kangaroo.svg";
import sun from "../../assets/icons/Sun.svg";
import water from "../../assets/icons/Water.svg";
import heart from "../../assets/icons/Heart.svg";

// Block attributes (custom props)
const blockAttributes = {
  headline: {
    type: "string",
    default: "What we do",
  },
  icons: {
    type: "array",
    default: [
      {
        image: mountain,
        href: null,
        target: null,
        text: "Protect Country and culture",
        editText: "Protect Country and culture",
      },
      {
        image: kangaroo,
        href: null,
        target: null,
        text: "Protect habitats and wildlife",
        editText: "Protect habitats and wildlife",
      },
      {
        image: sun,
        href: null,
        target: null,
        text: "Tackle climate change",
        editText: "Tackle climate change",
      },
      {
        image: water,
        href: null,
        target: null,
        text: "Sustainable water sharing",
        editText: "Sustainable water sharing",
      },
      {
        image: heart,
        href: null,
        target: null,
        text: "Promote healthy communities",
        editText: "Promote healthy communities",
      },
      {
        image: protest,
        href: null,
        target: null,
        text: "Defend the defenders",
        editText: "Defend the defenders",
      },
    ],
  },
};

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
  const { headline, icons } = attributes;

  // // eslint-disable-next-line react-hooks/rules-of-hooks
  // const [editing, setEditing] = useState([]);

  const iconsWithEditable = icons.map((icon, i) => ({
    image: icon.image,
    text: (
      <RichText
        value={icon.editText}
        multiline={false}
        onChange={(value) => {
          const newIcons = [...icons];
          newIcons[i].text = value.replace(/<\/?a[^>]*>/g, "");
          newIcons[i].editText = value;

          const hasLink = value.match(/href="([^"]*)/);
          const href = hasLink ? hasLink[1] : null;
          newIcons[i].href = href;

          const hasTarget = value.match(/target="([^"]*)/);
          const target = hasTarget ? hasTarget[1] : null;
          newIcons[i].target = target;

          const hasRel = value.match(/rel="([^"]*)/);
          const rel = hasRel ? hasRel[1] : null;
          newIcons[i].rel = rel;
          setAttributes({ icons: newIcons });
        }}
        tagName="span"
        placeholder={__("Hero Headline", "hero")}
        allowedFormats={['core/link']}
        keepPlaceholderOnFocus={true}
      />)
  }));

  // const label = __('Add Icon', 'directly add the only allowed block');
  // const iconsWithEditableAndControls = iconsWithEditable ? [
  //     ...iconsWithEditable,
  //     <Button
  //         // onFocus={ onFocus }
  //         // tabIndex={ tabIndex }
  //         // className={ classnames(
  //         //     className,
  //         //     'block-editor-button-block-appender'
  //         // ) }
  //         // onClick={ onToggle }
  //         label={label}
  //     >
  //         <VisuallyHidden as="span">{label}</VisuallyHidden>
  //         <Icon icon={plus} />
  //     </Button>
  // ] : iconsWithEditable;

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__("")}>
          <AttributesEditor
            blockAttributes={blockAttributes}
            attributes={attributes}
            setAttributes={setAttributes}
          />
        </PanelBody>
      </InspectorControls>

      <IconsWithDescription
        style={{ width: "100%", marginLeft: 0 }}
        headline={
          <RichText
            value={headline}
            multiline={false}
            onChange={(headline) => setAttributes({ headline })}
            placeholder={__("Hero Headline", "hero")}
            allowedFormats={[]}
            keepPlaceholderOnFocus={true}
          />
        }
        icons={iconsWithEditable}
      />
    </Fragment>
  );
};

// Save function (responsible for static HTML saved in database)
const save = ({ attributes }) => {
  const { headline, icons } = attributes;

  return <IconsWithDescription headline={<RichText.Content value={headline} />} icons={icons} />;
};

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-icons-with-description", {
  /**
   * This is the display title for your block, which can be translated with `i18n` functions.
   * The block inserter will show this name.
   */
  title: __("Impact Areas", "gutenberg-icons-with-description"),

  /**
   * An icon property should be specified to make it easier to identify a block.
   * These can be any of WordPress’ Dashicons, or a custom svg element.
   */
  icon: "align-pull-left",

  /**
   * Blocks are grouped into categories to help users browse and discover them.
   * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
   */
  category: "widgets",

  /**
   * Optional block extended support features.
   */
  // supports: {
  //     // Removes support for an HTML mode.
  //     html: false
  // },
  attributes: blockAttributes,

  /**
   * The edit function describes the structure of your block in the context of the editor.
   * This represents what the editor will render when the block is used.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
   *
   * @param {Object} [props] Properties passed from the editor.
   *
   * @return {WPElement} Element to render.
   */
  edit,

  /**
   * The save function defines the way in which the different attributes should be combined
   * into the final markup, which is then serialized by the block editor into `post_content`.
   *
   * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
   *
   * @return {WPElement} Element to render.
   */
  save,
});
